import React from 'react';
import { Container, CommomTitle, ImagesContainer, Image, CommomCentred, BannerCenterActions, BannerTitle, ColorLink, Card, CircleImageContainer, CardText, InfoList, PriceContainer, Price, OriginalPrice, DiscountBadge, CardButton  } from './styled';

import Button from "components/Button";
import { useHistory } from 'react-router-dom';

// // Caminhos das imagens (substitua com os caminhos corretos)
// const images = [
//     { src: '/images/Joinkids_plano_mensal.png', text: 'Texto 1' },
//     { src: '/images/Joinkids_plano_anual.png', text: 'Texto 2' }
   
//   ];

// const joinkids_image1 = '/images/Joinkids_plano_mensal.png';
// const joinkids_image2 = '/images/Joinkids_plano_anual.png';

const cardsData = [
    {
      title: 'Grátis',
      subtitle: 'Para começar',
      originalPrice: null,
      currentPrice: 'R$ 0',
      discount: null,
      period: '/sempre',
      isPopular: false,
      features: [
        '20 mensagens por dia',
        'Conversa com Salomão e Davi',
        'Modo Bate-papo em português',
        'Sem cartão de crédito',
      ],
      buttonText: 'Começar grátis',
      buttonStyle: 'secondary'
    },
    {
      title: 'Premium Mensal',
      subtitle: 'Mais popular',
      originalPrice: null,
      currentPrice: 'R$ 24,90',
      discount: null,
      period: '/mês',
      isPopular: true,
      features: [
        'Mensagens ilimitadas',
        'Todos os 4 personagens',
        'Modo Bate-papo + Modo Praticar Idiomas',
        'Mais de 10 idiomas disponíveis',
        'Cancele quando quiser',
      ],
      buttonText: 'Assinar agora',
      buttonStyle: 'primary'
    },
    {
      title: 'Premium Anual',
      subtitle: 'Melhor custo-benefício',
      originalPrice: 'R$ 298,80',
      currentPrice: 'R$ 179,90',
      discount: '40% OFF',
      period: '/ano',
      isPopular: false,
      features: [
        'Tudo do Premium Mensal',
        'Equivale a R$ 14,99/mês',
        'Acesso antecipado a novos personagens',
        'Suporte prioritário via WhatsApp',
      ],
      buttonText: 'Economizar 40%',
      buttonStyle: 'primary'
    }
];


const ResponsiveImagesSection = () => {

    const history = useHistory();
    const navigate = to => history.push(`/${ to }`);
    
  return (
    <Container>
      {/* Título */}
      <CommomTitle>Conheça nossos Planos</CommomTitle>

      {/* Container dos Cards */}
      <ImagesContainer>
        {cardsData.map((item, index) => (
          <Card key={index}>
            <div>
              {/* Título do plano */}
              <CardText>{item.title}</CardText>
              
              {/* Subtitle */}
              <div style={{ 
                fontSize: '1rem', 
                color: '#666', 
                marginBottom: '10px',
                fontWeight: '500',
                lineHeight: '1.2'
              }}>
                {item.subtitle}
              </div>

              {/* Badge de desconto */}
              {item.discount && (
                <DiscountBadge>{item.discount}</DiscountBadge>
              )}

              {/* Container de preço */}
              <PriceContainer>
                {item.originalPrice && (
                  <div>
                    <OriginalPrice>{item.originalPrice}</OriginalPrice>
                  </div>
                )}
                <Price>
                  {item.currentPrice}
                  <span style={{ 
                    fontSize: '1rem', 
                    fontWeight: 'normal', 
                    color: '#666',
                    lineHeight: '1.1'
                  }}>
                    {item.period}
                  </span>
                </Price>
              </PriceContainer>

              {/* Lista de funcionalidades */}
              <InfoList>
                {item.features.map((feature, idx) => (
                  <li key={idx}>{feature}</li>
                ))}
              </InfoList>
            </div>

            {/* Botão de ação */}
            <CardButton>
              {item.buttonStyle === 'secondary' ? (
                <Button secondary onClick={() => navigate('register?plan=free')}>
                  {item.buttonText}
                </Button>
              ) : (
                <Button primary onClick={() => navigate('planos')}>
                  {item.buttonText}
                </Button>
              )}
            </CardButton>
          </Card>
        ))}


        {/* <Image src={joinkids_image1} alt="Imagem 1" />
        <Image src={joinkids_image2} alt="Imagem 2" /> */}
      </ImagesContainer>

      <CommomTitle>Comece grátis hoje. Evolua quando quiser.</CommomTitle>

      <BannerCenterActions>
        <Button green onClick={() => navigate('register?plan=free')}>Começar grátis</Button>
        <BannerTitle><a href="https://wa.me/5516982026554?text=Eu%20tenho%20d%C3%BAvidas%20sobre%20o%20TiqChat!"><ColorLink><Button white>Falar no WhatsApp</Button></ColorLink></a></BannerTitle>
      </BannerCenterActions>

    </Container>
  );
};

export default ResponsiveImagesSection;

//<Youtube videoId={`dUxUDhSRd8M`} key={`dUxUDhSRd8M`}/>
// na linha 32 <Player autoplay={true}>